import React from 'react'
import PropTypes from 'prop-types'

import { Button, Col, FormCheckbox, FormGroup, FormInput, FormSelect, Row } from 'shards-react'
import { ORG_TYPES } from '../../../../../constants/const'

const DiseasedPeriodForm = ({ orgList, onSubmit, setFormData, formData }) => {
  const handleInputChange = e => {
    const {name, value} = e.target
    const school = (name === 'idOrg' && value !== '0') ? 0 : formData.school
    setFormData({...formData, school, [name]: value})
  }

  return (
    <Row className={'my-3 justify-content-between'}>
      <Col md={'auto'} className={'d-flex align-items-center'}>
        <FormGroup className={'mr-3'}>
          <label htmlFor='_to'>Дата</label>
          <FormInput
            size='sm'
            type={'date'}
            name={'dateto'}
            className='mb-2'
            value={formData.dateto}
            onChange={e =>
              setFormData({
                ...formData,
                datefrom: e.target.value,
                dateto: e.target.value,
              })
            }
          />
        </FormGroup>
        <FormGroup className={'mr-3'}>
          <label htmlFor='_idOrg'>Выберите организацию</label>
          <FormSelect
            name={'idOrg'}
            id='_idOrg'
            size='sm'
            className='mb-2 d-block'
            onChange={handleInputChange}
            style={{ width: 730 }}
          >
            <option value={0}>Все организации</option>
            {orgList &&
              orgList.map(item => (
                <option key={item.idOrganization} value={item.idOrganization}>
                  {item.orgName}
                </option>
              ))}
          </FormSelect>
        </FormGroup>
        {formData.idOrg === '0' && (
          <FormGroup className={'mr-3'}>
            <label htmlFor='_idOrg'>Тип ОО</label>
            <FormSelect
              name='school'
              size='sm'
              className='mb-2 d-block'
              onChange={handleInputChange}
            >
              {ORG_TYPES.map(({name, value}) => <option key={value} value={value}>{name}</option>)}
            </FormSelect>
          </FormGroup>
        )}
        <Button onClick={onSubmit}>Создать отчет</Button>
      </Col>
    </Row>
  )
}

DiseasedPeriodForm.propTypes = {
  orgList: PropTypes.array,
  onSubmit: PropTypes.func,
}

export default DiseasedPeriodForm
